import React, { useEffect, useState } from 'react'

import { Button, Col, Row, notification } from 'antd'

// Component
import Loader from '../components/Loader'
import Empty from '../components/Empty'
import NewRosterCard from '../components/NewRosterCard'

import { getRoster, setNonActivePlayer } from '../redux/actions/rosterAction'
import { useSelector } from 'react-redux'
import { isLocked } from '../config/constants'
import { sortedArray } from '../config/helperFunctions'
import PlayerDetailsModal from '../components/modal/PlayerDetailsModal'
import MainHeader from '../components/MainHeader'

const PlayerRoster = () => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const USER = useSelector((state) => state?.user)
  const { data, nonActivePlayer, isLoading } = useSelector((state) => state?.roster)
  const [nonActive, setNonActive] = useState(nonActivePlayer)
  const [submitLoading, setSubmitLoading] = useState(false)

  const handleNonActive = (event, id) => {
    if (event) {
      setNonActive([...nonActive, id])
    } else {
      const temp = [...nonActive]
      let keyInd = temp?.indexOf(id)
      if (keyInd !== -1) {
        temp.splice(keyInd, 1)
        setNonActive(temp)
      }
    }
  }

  const handleSubmit = async () => {
    if (nonActive?.length === 3) {
      setSubmitLoading(true)
      await setNonActivePlayer(
        {
          ids: nonActive,
        },
        SETTING.date,
      )
      setSubmitLoading(false)
    } else {
      notification.error({
        message: `Select at least 3 Players (${nonActive?.length}/3)`,
        duration: 3,
      })
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    getAllRoster()
  }, [SETTING?.date])

  useEffect(() => {
    setNonActive(nonActivePlayer)
  }, [nonActivePlayer])

  const getAllRoster = async () => {
    await getRoster(SETTING?.date)
  }

  return (
    <div className='player_roster_container'>
      <MainHeader />

      {isLoading ? (
        <Loader />
      ) : (
        <Row gutter={[30, 30]}>
          <Col xs={24} lg={16}>
            <div style={{ overflowX: 'auto' }}>
              <div style={{ minWidth: '800px' }}>
                <>
                  {/* ----------------------------------------------------------- */}
                  <div className='practice_squad_header' style={{ marginTop: '20px' }}>
                    <p className='heading'>
                      ACTIVE<b>ROSTER</b>
                    </p>
                    {!isLocked() && (
                      <Button loading={submitLoading} onClick={handleSubmit} type='primary'>
                        Submit
                      </Button>
                    )}
                  </div>
                  <section className='stats_container'>
                    {data?.active?.length > 0 ? (
                      sortedArray(data?.active)
                        ?.filter((x) => x?.isActive === true)
                        ?.map((v, i) => {
                          return (
                            <NewRosterCard
                              key={i}
                              data={v}
                              index={i}
                              state={nonActive}
                              handleClick={handleNonActive}
                              checkbox={true}
                              isTeam={{ teamLogo: USER?.userDetails?.team?.logo }}
                              isOwnRoster={{
                                status: true,
                              }}
                            />
                          )
                        })
                    ) : (
                      <Empty text={'active roster is empty'} />
                    )}
                  </section>
                  {/* ----------------------------------------------------------- */}
                  <div className='practice_squad_header' style={{ marginTop: '20px' }}>
                    <p className='heading'>
                      NON-ACTIVE<b>ROSTER</b>
                    </p>
                  </div>
                  <section className='stats_container'>
                    {data?.active?.length > 0 ? (
                      sortedArray(data?.active)
                        ?.filter((x) => x?.isActive !== true)
                        ?.map((v, i) => {
                          return (
                            <NewRosterCard
                              key={i}
                              data={v}
                              index={i}
                              state={nonActive}
                              handleClick={handleNonActive}
                              checkbox={true}
                              isTeam={{ teamLogo: USER?.userDetails?.team?.logo }}
                              isOwnRoster={{
                                status: true,
                              }}
                            />
                          )
                        })
                    ) : (
                      <Empty text={'non-active roster is empty'} />
                    )}
                  </section>
                  {/* ----------------------------------------------------------- */}
                  <hr style={{ marginBlock: '20px' }} />
                  <div className='practice_squad_header'>
                    <p className='heading'>
                      PROTECTED<b>LIST</b>
                    </p>
                  </div>
                  <section className='stats_container'>
                    {data?.practice?.length > 0 ? (
                      sortedArray(data?.practice)?.map((v, i) => {
                        return (
                          <NewRosterCard
                            key={i}
                            data={v}
                            index={i}
                            isPractice={true}
                            checkbox={false}
                            isReserve={true}
                            isTeam={{ teamLogo: USER?.userDetails?.team?.logo }}
                            isOwnRoster={{
                              status: true,
                            }}
                          />
                        )
                      })
                    ) : (
                      <Empty text={'protected list is empty'} />
                    )}
                  </section>
                  {/* ----------------------------------------------------------- */}
                  <hr style={{ marginBlock: '20px' }} />
                  <div className='practice_squad_header'>
                    <p className='heading'>
                      RESERVE<b>LIST</b>
                    </p>
                  </div>
                  <section className='stats_container'>
                    {data?.reserved?.length > 0 ? (
                      sortedArray(data?.reserved)?.map((v, i) => {
                        return (
                          <NewRosterCard
                            key={i}
                            data={v}
                            index={i}
                            isPractice={true}
                            checkbox={false}
                            isTeam={{ teamLogo: USER?.userDetails?.team?.logo }}
                            isOwnRoster={{
                              status: true,
                            }}
                          />
                        )
                      })
                    ) : (
                      <Empty text={'reserve list is empty'} />
                    )}
                  </section>
                  {/* ---------------------------------------------------- */}
                  <hr style={{ marginBlock: '20px' }} />
                  <div className='practice_squad_header'>
                    <p className='heading'>
                      Draft<b>Picks</b>
                    </p>
                  </div>
                  <section className='draft_pick_box'>
                    {data?.drafts?.length > 0 ? (
                      data?.drafts?.map((v, i) => {
                        return (
                          <div key={i} className='draft_pick_row'>
                            <p>{`${v?.season}' ${v?.team?.name} ${v?.round} Round Pick`}</p>
                          </div>
                        )
                      })
                    ) : (
                      <Empty text={'DRAFT PICK IS EMPTY'} />
                    )}
                  </section>
                  {/* ---------------------------------------------------- */}
                </>
              </div>
            </div>
          </Col>
        </Row>
      )}
      <PlayerDetailsModal />
    </div>
  )
}

export default PlayerRoster
